export default "__VITE_ASSET__973f94e3__"